"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedDesktopDropdownMenu = void 0;
const react_1 = __importDefault(require("react"));
const DescribeColumn_1 = require("./DescribeColumn");
const ExternalColumn_1 = require("./ExternalColumn");
const EnhancedDropdownLayout_1 = require("./EnhancedDropdownLayout");
const MainLinks_1 = require("./MainLinks");
const DropdownSummary_1 = require("../menu/DropdownSummary");
const Menu_styles_1 = require("../menu/Menu.styles");
const enhancedDropdownUtils_1 = require("../../utils/enhancedDropdownUtils");
const menu_hooks_1 = require("../../shared/menu.hooks");
const EnhancedDesktopDropdownMenu = ({ links = [], summaryNode, enhancedDrodown = {}, menuId, locale }) => {
    const { describeColumn = {}, externalColumn = {} } = enhancedDrodown;
    const { open: menuOpen, setActiveMenu } = (0, menu_hooks_1.useMyActiveMenu)(menuId);
    const openMenu = (0, menu_hooks_1.useOpenMenu)(menuId);
    const closeMenu = (0, menu_hooks_1.useCloseMenu)();
    const toggleMenu = (0, menu_hooks_1.useToggleMenu)(menuOpen, setActiveMenu, menuId);
    const mainLinkBorderRight = (0, enhancedDropdownUtils_1.isValidExternalColumn)(externalColumn);
    let customMainLinks;
    if (enhancedDrodown && enhancedDrodown.mainLinksNode) {
        customMainLinks = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, enhancedDrodown.mainLinksNode), { links, locale });
    }
    let customExternalColumn;
    if (externalColumn && externalColumn.externalColumnNode) {
        customExternalColumn = react_1.default.cloneElement(react_1.default.createElement(react_1.default.Fragment, null, externalColumn.externalColumnNode), Object.assign(Object.assign({}, externalColumn), { locale }));
    }
    return (react_1.default.createElement(Menu_styles_1.Menu, { role: "menu", static: true, onMouseEnter: openMenu, onMouseLeave: closeMenu },
        react_1.default.createElement(DropdownSummary_1.DropdownSummary, { menuId: menuId, openMenu: openMenu, onKeyUp: toggleMenu }, summaryNode),
        react_1.default.createElement(EnhancedDropdownLayout_1.EnhancedDropdownLayout, { menuOpen: menuOpen },
            react_1.default.createElement(DescribeColumn_1.DescribeColumn, Object.assign({}, describeColumn, { locale: locale })),
            customMainLinks || react_1.default.createElement(MainLinks_1.MainLinks, { links: links, borderRight: mainLinkBorderRight, locale: locale }),
            customExternalColumn || react_1.default.createElement(ExternalColumn_1.ExternalColumn, Object.assign({}, externalColumn, { locale: locale })))));
};
exports.EnhancedDesktopDropdownMenu = EnhancedDesktopDropdownMenu;
//# sourceMappingURL=EnhancedDesktopDropdownMenu.js.map